export class ReaderViewManager {
  constructor(onTitlePage) {
    this.onTitlePage = onTitlePage
  }

  start() {
    this._setupSkipToContent()
    this._resizeFont()
  }

  _resizeFont() {
    var fontSize = Math.max(
      50,
      Math.min(200, $.jStorage.get('reader_font_size') || 100)
    )
    $('#bookcontent').css('font-size', `${fontSize}%`) // We need to find a way to use .addClass() here instead
  }

  _setupSkipToContent() {
    if (this.onTitlePage) {
      $('.SkipToMainContentLink').attr('href', '#book_contents')
    }

    // Taken from recipe found here:
    // https://www.bignerdranch.com/blog/web-accessibility-skip-navigation-links/
    $('.SkipToMainContentLink').on('click', function () {
      $(`#${this.href.split('#')[1]}`)
        .attr('tabindex', -1)
        .on('blur focusout', function () {
          $(this).removeAttr('tabindex')
        })
        .trigger('focus')
      // after focus, scroll the element in view super fast but with
      // an offset so the navbar doesn't cover it
      let focusEl = $('#book_contents').get(0)
        ? $('#book_contents') // title page
        : $('#bookcontent') // book pages
      $('html, body').animate(
        { scrollTop: focusEl.offset().top - 300 },
        10 // Need some time here for some reason.My guess is this is an actual race condition...
      )
    })
  }
}
